import * as React from 'react'
import LibUserAvatar from 'react-user-avatar'

// const defaultPalette = [
// 	"#9ABF06", // olive-ish
// 	"#2E99B0", // cyan
// 	"#9F73FF", // ultralight purple
// 	"#F23D68", // pink
// 	"#FFBE5C", // mustard
// 	"#4AD9A5", // light green
// ]

// Separate palette with lighter purple colors
const defaultPalette = ['#E5D9FF', '#C2A6FF', '#D3BFFF', '#9D82D9']

export interface UserAvatarProps {
  name: string

  src?: string
  srcset?: string

  color?: string
  colors?: string[]

  size?: number
  borderRadius?: string | number

  style?: React.StyleHTMLAttributes<HTMLDivElement> & React.CSSProperties
}

export const UserAvatar: React.FC<UserAvatarProps> = (props) => {
  const { colors = defaultPalette, ...restProps } = props

  return <LibUserAvatar colors={colors} {...restProps} />
}
